import React, { Component } from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import { userListByGroupRequest, userListRequest } from "../../../reduxRelated/actions/userActions";
import { ToastService } from "../../../utils/toastify";
import { languageService } from "../../../Language/language.service";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import CustomForm from "../../../libraries/form";
import UISectionHeader from "../../Common/UISectionHeader";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { getDate } from "../../../utils/dateParser";
import { hosViolationSearchFiltersFormSchema } from "./schemas/hosViolationSearchFiltersFormSchema";
import _ from "lodash";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import { dataFormatters } from "../../../utils/dataFormatters";
import ThisTable from "../../Common/ThisTable";
import moment from "moment";
import { printer } from "react-icons-kit/icomoon/printer";
import SvgIcon from "react-icons-kit";
import { getLoggedInUser } from "../../MainPage/UserInfo";
import { commonPageStyle } from "../../Common/Summary/styles/CommonPageStyle";
import { themeService } from "../../../theme/service/activeTheme.service";
import { TableCellScrollable } from "../Helper/TableUtils";
import "./styles.css";
import ReportTitleSection from "../../../libraries/ReportGenerator/ReportTitleSection";
import { Col, Row } from "reactstrap";
import ReportInfoSection from "../../../libraries/ReportGenerator/ReportInfoSection";
import { dateSort } from "../../../utils/sortingMethods";

class HosViolationReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showloader: false,
      searchFiltersFormSchema: null,
      searchFilters: {},
      dateRange: {},
      searchUser: null,
      users: [],
      loggedInUser: getLoggedInUser(),
      searchResult: [],
    };

    this.compileSearchHosRecordsFormSchema = this.compileSearchHosRecordsFormSchema.bind(this);
    this.loadUrlSearchFormParams = this.loadUrlSearchFormParams.bind(this);
    this.setShowLoader = this.setShowLoader.bind(this);
    this.violationsSearchRecords = this.violationsSearchRecords.bind(this);
    this.printReport = this.printReport.bind(this);
    this.convertToReadableDate = this.convertToReadableDate.bind(this);
  }

  componentDidMount() {
    // Fetch All Users
    this.props.userListRequest();
  }

  convertToReadableDate(date) {
    let tempDate = getDate(date);
    if (tempDate === null) {
      return date;
    } else {
      return tempDate.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { actionType, userActionType, HosViolationReport, userList } = this.props;
    if (userActionType !== prevProps.userActionType) {
      if (userActionType === "USER_LIST_REQUEST") {
        this.setShowLoader(true);
      } else if (userActionType === "USER_LIST_SUCCESS") {
        // save select options for users
        if (Array.isArray(userList)) {
          this.setState(
            {
              users: [...userList],
              searchFiltersFormSchema: this.compileSearchHosRecordsFormSchema(),
            },
            () => this.loadUrlSearchFormParams(),
          );
        }
        this.setShowLoader(false);
      } else if (userActionType === "USER_LIST_FAILURE") {
        this.setShowLoader(false);
      }
    }

    if (actionType !== prevProps.actionType) {
      if (actionType === "HOSVIOLATIONREPORT_READ_REQUEST") {
        this.setShowLoader(true);
      } else if (actionType === "HOSVIOLATIONREPORT_READ_SUCCESS") {
        this.setState({
          searchResult: HosViolationReport,
        });

        this.setShowLoader(false);
      } else if (actionType === "HOSVIOLATIONREPORT_READ_FAILURE") {
        this.setShowLoader(false);
      }
    }
  }

  compileSearchHosRecordsFormSchema() {
    let formSchema = updateShortSchema(_.cloneDeep(hosViolationSearchFiltersFormSchema));
    return formSchema;
  }

  setShowLoader(status) {
    this.setState({ showloader: status });
  }
  printReport() {
    window.print();
  }

  loadUrlSearchFormParams() {
    const { stateRetention } = this.props;

    if (this.props.stateRetention.searchViolationFilters) {
      const searchParams = new URLSearchParams(stateRetention.searchViolationFilters);
      let prevFormData = {
        startDate: getDate(searchParams.get("startDate")),
        endDate: getDate(searchParams.get("endDate")),
      };

      this.violationsSearchRecords({ fields: prevFormData }, true);
    }
  }

  violationsSearchRecords(submission, loadPrevState = false) {
    const { getHosViolationReport } = this.props;

    this.setState({
      searchUser: null,
      searchResult: [],
    });

    let today = moment().startOf("day");
    const dateFields = _.cloneDeep(submission.fields);
    this.setState({
      searchFilters: dateFields,
      dateRange: {
        startDate: this.convertToReadableDate(dateFields.startDate || moment(dateFields.endDate || today).subtract(14, "days")),
        endDate: this.convertToReadableDate(dateFields.endDate || today),
      },
    });

    let filters = JSON.parse(JSON.stringify(submission.fields));

    filters.startDate && (filters.startDate = dataFormatters.getMomentDateInDifferentTimezone(filters.startDate, filters.timezone));

    filters.startDate = filters.startDate ? filters.startDate : null;
    filters.endDate = filters.endDate ? filters.endDate : null;

    if (filters.startDate && filters.endDate && filters.startDate.isAfter(filters.endDate)) {
      ToastService.Error(`${languageService("Error")}: `, languageService("Search period start date should not be after the end date."));
      return;
    }
    filters = JSON.parse(JSON.stringify(filters));
    const searchQueryString = `?${new URLSearchParams(filters)}`;

    if (!loadPrevState) {
      this.props.stateRetention.set("searchViolationFilters", searchQueryString);
    }

    getHosViolationReport && getHosViolationReport(`usersViolations/${searchQueryString}`);
  }

  render() {
    const { searchFiltersFormSchema, searchFilters, searchResult, dateRange, loggedInUser, showPagination } = this.state;
    const loggedInUserName = loggedInUser && loggedInUser.name ? loggedInUser.name.toString().toUpperCase() : "";
    return (
      <div>
        <div className="no-print">
          <UISectionHeader title={languageService("Search HOS Non-Compliant Records")} />
          <SpinnerLoader spinnerLoading={this.state.showloader} />
          {searchFiltersFormSchema && (
            <CustomForm
              hideFormTitle={true}
              mode="inline"
              fieldsData={searchFilters}
              formSchema={searchFiltersFormSchema}
              parentRef={{
                violationsSearchRecords: this.violationsSearchRecords,
              }}
            />
          )}

          <UISectionHeader
            title={languageService("Results")}
            postTitleContent={
              <React.Fragment>
                {searchResult && searchResult.length != 0 && (
                  <div
                    className="report-print"
                    style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                    onClick={(e) => {
                      this.printReport();
                    }}
                  >
                    <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                      {languageService("Print Report")}
                    </span>
                    <SvgIcon icon={printer} size={24} />
                  </div>
                )}
              </React.Fragment>
            }
          />
        </div>
        <div className="mainContent table-report last-page-break-print">
          <div className="hos-violation-report-header">
            <React.Fragment>
              <ReportTitleSection
                title="HOS Non-Compliance Report"
                centerTitle={true}
                fontSizeOverride={"36px"}
                overrideTitleStyle={{ alignItems: "center" }}
              />

              <ReportInfoSection
                fontSizeOverride={"20px"}
                rows={[
                  {
                    col1: {
                      title: "Printed By",
                      value: loggedInUserName,
                    },
                    col2: {
                      title: "Date Range",
                      value: dateRange.startDate && dateRange.endDate ? `${dateRange.startDate} - ${dateRange.endDate}` : null,
                    },
                  },
                ]}
              />

              <span className="spacer"></span>
            </React.Fragment>
          </div>
          <div className="hos-violation-report-table">
            <ThisTable
              tableColumns={[
                {
                  Header: languageService("Name"),
                  accessor: "name",
                  id: "name",
                  style: { whiteSpace: "unset" },
                  minWidth: 100,
                },

                {
                  Header: languageService("Location"),
                  id: "location",
                  accessor: (d) => {
                    const startLoc = d.startLoc ? d.startLoc.description : "";
                    const endLoc = d.endLoc ? d.endLoc.description : "";
                    return `${startLoc} - ${endLoc}`;
                  },
                  style: { whiteSpace: "unset" },
                  minWidth: 100,
                },

                {
                  Header: languageService("Start Date & Time"),
                  id: "startDate",
                  accessor: "startDate",
                  style: { whiteSpace: "unset" },
                  Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
                  minWidth: 100,
                  sortMethod: dateSort,
                },
                {
                  Header: languageService("End Date & Time"),
                  id: "endDate",
                  accessor: "endDate",
                  style: { whiteSpace: "unset" },
                  Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
                  minWidth: 100,
                  sortMethod: dateSort,
                },
                {
                  Header: languageService("Violation"),
                  accessor: "message",
                  id: "message",
                  style: { whiteSpace: "unset" },
                  minWidth: 200,
                },

                {
                  Header: languageService("Reason"),
                  accessor: "reason",
                  id: "reason",
                  style: { whiteSpace: "unset" },
                  minWidth: 200,
                },
              ]}
              tableData={searchResult}
              pagination={false}
              forDashboard={false}
              height={"auto"}
              overrideRowStyle={{ minHeight: "35px", height: "auto", background: "var(--fifth)", breakInside: "avoid" }}
            />
          </div>
        </div>
      </div>
    );
  }
}

HosViolationReport.contextType = FixedAppLookupsContext;

let variableList = {
  userReducer: {
    userList: [],
    userListByGroup: [],
  },
};
let reducers = ["userReducer"];

let actionOptions = {
  read: true,
  others: { userListRequest, userListByGroupRequest },
};

const HosViolationReportContainer = CRUDFunction(
  HosViolationReport,
  "HosViolationReport",
  actionOptions,
  variableList,
  reducers,
  "hoursofservice",
);

export default HosViolationReportContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosViolationReport/index.js